import { Grid, IconButton } from "@mui/material";

import DownloadIcon from "@mui/icons-material/Download";
import AssignmentIcon from "@mui/icons-material/Assignment";

import { useEffect, useState, useCallback } from "react";
import { getFile, downloadFile } from "../../services/ReportService";
import { useAuth } from "../../context/AuthContext";
import DatagridCustom from "../General/DatagridCustom";
import { useToast } from "../../context/ToastContext";

export default function ReportProcessedNewsFile() {
  const { showToast } = useToast();
  const [files, setFiles] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });
  const { hasPermission } = useAuth();

  const fetchFiles = useCallback(async () => {
    setLoading(true);
    try {
      const searchTerm = filterModel.quickFilterValues?.join(" ") || "";
      const { page, pageSize } = paginationModel;

      let response = await getFile({
        page: page + 1,
        perPage: pageSize,
        search: searchTerm,
      });

      response = response?.data;

      if (response.status === "success") {
        setFiles(response.data);
        setTotal(response.total);
      } else {
        showToast("Error al cargar archivos.", "error")
      }
    } catch (error) {
      console.error("Error al cargar archivos:", error);
      showToast("No se pudieron cargar los archivos. Intente más tarde.", "error")
    } finally {
      setLoading(false);
    }
  }, [paginationModel, filterModel, showToast]);

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  const handleFilterModelChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
    if (
      (filterModel.quickFilterValues?.join(" ") || "") !==
      (newFilterModel.quickFilterValues?.join(" ") || "")
    ) {
      setPaginationModel((prev) =>
        prev.page !== 0 ? { ...prev, page: 0 } : prev
      );
    }
  };

  const columns = [
    {
      field: "fileName",
      headerName: "Archivo",
      flex: 3,
    },
    {
      field: "lastModified",
      headerName: "Última Modificación",
      flex: 2,
      valueGetter: (params) => {
        const date = new Date(params);

        if (isNaN(date.getTime())) {
          return "Fecha inválida";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
    },
    {
      field: "url",
      headerName: "Descargar",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const handleDownload = async () => {
          try {
            const response = await downloadFile(params.value);

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", params.value); // nombre del archivo
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          } catch (error) {
            console.error("Error al descargar archivo:", error);
          }
        };

        return (
          <IconButton
            color="primary"
            aria-label="descargar archivo"
            onClick={handleDownload}
            disabled={!hasPermission("descargar archivo novedades procesado")}
          >
            <DownloadIcon />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

        <DatagridCustom
          rows={files}
          columns={columns}
          getRowId={(row) => row.fileName}
          title="Listado de Archivos Generados en Novedades"
          description="Visualice los archivos que se generaron por abogado al solicitar novedades."
          icon={<AssignmentIcon sx={{ fontSize: 32 }} />}
          // error={globalError}
          success={false}
          paginationModel={paginationModel}
          onPaginationChange={setPaginationModel}
          total={total}
          loading={loading}
          filterModel={filterModel}
          onFilterChange={handleFilterModelChange}
          filterMode="server"
          isServerPagination={true}
        />
      </Grid>
    </Grid>
  );
}
